// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BenefitTabContent_wrapper__CT7lT","tabsContainer":"BenefitTabContent_tabsContainer__Ih55O","tabsContainerOverflow":"BenefitTabContent_tabsContainerOverflow__Bl8Ta"};